/*
 * File: /src/store/modules/imageAssets.js
 * Created Date: Sunday March 17th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 2nd April 2019 11:14:02 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import { authedAxios } from '../../shared/axiosWrapper';

// initial state
const state = {
  images: [{test: '', name: ''}],
};

// getters return values
const getters = {
  getImages: state => {
    return state.images;
  },
  getImageById: state => id => {
    return state.images.find(image => {
      if (image.id === id) {
        return image;
      }
    });
  }
};

// actions return promises
const actions = {
  fetchImages({ commit }) {
    return new Promise((resolve, reject) => {
      // TODO: relative urls?
      authedAxios
        .get('/v1/images')
        .then(response => {
          // cast as an array.
          let images = [];
          for (const id in response.data) {
            images.push(response.data[id]);
          }
          commit('setImages', images);
          resolve({
            success: 1,
            data: images,
            error: undefined
          });
        })
        .catch(e => {
          reject({
            success: 0,
            data: undefined,
            error: e
          });
        });
    });
  },
  loadById({ commit, getters }, id) {
    const image = getters.getImageById(id);
    if (image) {
      return Promise.resolve(image);
    }

    // TODO: relative url?
    return authedAxios.get('/v1/images/' + id).then(response => {
      commit('addImage', response.data);
      return getters.getImageById(id);
    });
  },
  addNewImage({ commit }, image) {
      console.log('adding an image', image);
      commit('addImage', image);
  },
  clearImages({ commit }) {
    commit('setImages', []);
  },
};

// mutations
const mutations = {
  addImage(state, imageData) {
    state.images.push(imageData);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
